import {initWebComponent} from "@/helpers/web-component-helper";
import {
    getAllBySelector,
    getBySelector,
    getValueBySelector, hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {addTemporaryLayer} from "@/helpers/layer/temporary/temporary-layer-helper";
import {BookmarkDataSetFileComponent} from "@/components/bookmark/dataset/bookmark-data-set-file-component";
import {BookmarkDataSetWebserviceComponent} from "@/components/bookmark/dataset/bookmark-data-set-webservice-component";

let layerCapabilities = []

export class BookmarkDataSetComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
<div class="card m-3 bg-lighter" style="border-radius: 10px;">
     <div class="card-header font-weight-bold p-2">
         <span class="fa fa-file-import navbar-icon" style="font-size:15px"></span>
         Data importeren
         <button class="ml-1 btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
            <span class="fa fa-times"></span>
         </button>
     </div>
     
        <div class="card-body p-2">
            <div class="mt-1">
                <div class="btn-group btn-group-toggle bg-light p-1 d-flex" data-toggle="buttons">
                    <label class="btn btn-default btn-tools btn-sm md-btn-flat waves-effect active" id="btnAddDataSetWebService">
                        Web Service
                    </label>
                    <label class="btn btn-default btn-tools btn-sm md-btn-flat waves-effect" id="btnAddDataSetFile">
                        Bestand
                    </label>
                </div>
            </div>
        </div>
        
        <bookmark-data-set-webservice></bookmark-data-set-webservice>
        <bookmark-data-set-file class="d-none"></bookmark-data-set-file>
     </div>
`
        initWebComponent(this, template)

        getBySelector('#btnAddDataSetWebService').addEventListener('click', evt => {
            evt.target.classList.add('active')
            removeClassBySelector('#btnAddDataSetFile', 'active')
            hideElementsBySelector('bookmark-data-set-file')
            showElementsBySelector('bookmark-data-set-webservice')
        })
        getBySelector('#btnAddDataSetFile').addEventListener('click', evt => {
            evt.target.classList.add('active')
            removeClassBySelector('#btnAddDataSetWebService', 'active')
            hideElementsBySelector('bookmark-data-set-webservice')
            showElementsBySelector('bookmark-data-set-file')

        })
    }
}

window.customElements.define("bookmark-data-set-file", BookmarkDataSetFileComponent);
window.customElements.define("bookmark-data-set-webservice", BookmarkDataSetWebserviceComponent);
